import styled from 'styled-components'

export const P = styled.p`
  font-family: "SF Pro Display";
  font-size: 16px;
  color: #172129;
  line-height: 24px;
  margin: 14px 0;
`



// WEBPACK FOOTER //
// ./src/atoms/P.tsx